import React from "react";
import { BusinessCreditReportStatePII } from "../../../store/businessCreditReportService/types";

interface IProps {
    reportObject: BusinessCreditReportStatePII;
}
const PaydexScore: React.FunctionComponent<IProps> = (props) => {
    const paydexScore = Number(props.reportObject.businessCompanyReport?.credit_score_and_limit?.paydex_score);
    let scoreLevel;

    if (paydexScore >= 80 && paydexScore <= 100) {
        scoreLevel = "lvl-very-low-risk";
    } else if (paydexScore >= 50 && paydexScore <= 79) {
        scoreLevel = "lvl-high-risk";
    } else if (paydexScore >= 0 && paydexScore <= 49) {
        scoreLevel = "lvl-very-high-risk";
    }

    const scoreDotPosition = (score: any) => {
        const dotOffset = 100 - score;
        const topStyles = {
            top: (dotOffset > 95 ? 95 : dotOffset) + "%",
        } as React.CSSProperties;

        return topStyles;
    };

    const scoreValuePosition = (score: any) => {
        const dotOffset = 100 - score;
        const topStyles = {
            top: (dotOffset > 85 ? 85 : dotOffset) + "%",
        } as React.CSSProperties;

        return topStyles;
    };

    const scoreDotBorder = (level: any) => {
        switch (level) {
            case "lvl-very-low-risk":
                return "paydex-score-dot paydex-green-border";
            case "lvl-high-risk":
                return "paydex-score-dot paydex-orange-border";
            case "lvl-very-high-risk":
                return "paydex-score-dot paydex-red-border";
        }
    };

    const scoreDescription = (level: any) => {
        switch (level) {
            case "lvl-very-low-risk":
                return "Low risk of late payment";
            case "lvl-high-risk":
                return "Medium risk of late payment";
            case "lvl-very-high-risk":
                return "High risk of late payment";
        }
    };

    return (
        <React.Fragment>
            <div className="row full-width between-xs margin-bottom-l payment-table-header">
                <div className="col-xs flex-grow-null">
                    <h4 className="content-sub-title">PAYDEX® Score</h4>
                </div>
            </div>
            {paydexScore ? (
                <div className="paydex-outer-container flex-block">
                    <div className="paydex-inner-container">
                        <div>
                            <div className="paydex-color-bar">
                                <div className={scoreDotBorder(scoreLevel)} style={scoreDotPosition(paydexScore)}>
                                    <div className={"paydex-score-line " + scoreLevel} />
                                </div>
                                <div className="paydex-bar lvl-very-low-risk-bg" />
                                <div className="paydex-bar lvl-high-risk-bg" />
                                <div className="paydex-bar lvl-very-high-risk-bg" />
                            </div>

                            <div className={paydexScore < 20 ? "paydex-score-value zeroScore" : "paydex-score-value"} style={scoreValuePosition(paydexScore)}>
                                <div className="score-value">{paydexScore}</div>
                                <div className="score-label">
                                    <div className={scoreLevel + "-bg"} />
                                    <div>{scoreDescription(scoreLevel)}</div>
                                </div>
                            </div>
                        </div>

                        <div>
                            <p>Your PAYDEX&reg; Score assigns your company a 0-100 rating based on past payment performance as reported to Dun & Bradstreet.</p>

                            <div className="paydex-list">
                                <div className={paydexScore === 100 ? "bold" : ""}>
                                    <span>100</span>
                                    <span>30 Days Before Terms (Anticipate)</span>
                                </div>

                                <div className={paydexScore >= 90 && paydexScore < 100 ? "bold" : ""}>
                                    <span>90</span>
                                    <span>20 Days Before Terms (Discount)</span>
                                </div>

                                <div className={paydexScore >= 80 && paydexScore < 90 ? "bold" : ""}>
                                    <span>80</span>
                                    <span>0 Days on Terms (Prompt)</span>
                                </div>

                                <div className={paydexScore >= 70 && paydexScore < 80 ? "bold" : ""}>
                                    <span>70</span>
                                    <span>15 Days Beyond Terms</span>
                                </div>

                                <div className={paydexScore >= 60 && paydexScore < 70 ? "bold" : ""}>
                                    <span>60</span>
                                    <span>22 Days Beyond Terms</span>
                                </div>

                                <div className={paydexScore >= 50 && paydexScore < 60 ? "bold" : ""}>
                                    <span>50</span>
                                    <span>30 Days Beyond Terms</span>
                                </div>

                                <div className={paydexScore >= 40 && paydexScore < 50 ? "bold" : ""}>
                                    <span>40</span>
                                    <span>60 Days Beyond Terms</span>
                                </div>

                                <div className={paydexScore >= 30 && paydexScore < 40 ? "bold" : ""}>
                                    <span>30</span>
                                    <span>90 Days Beyond Terms</span>
                                </div>

                                <div className={paydexScore >= 20 && paydexScore < 30 ? "bold" : ""}>
                                    <span>20</span>
                                    <span>120 Days Beyond Terms</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="box">
                    <div className="box-content text-align-center">There is no Paydex® Score data.</div>
                </div>
            )}
        </React.Fragment>
    );
};

export default PaydexScore;
